import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-information-block',
    templateUrl: './information-block.component.html',
    styleUrls: ['./information-block.component.scss'],
    standalone: false
})
export class InformationBlockComponent {
  @Input() description: string = '';
  @Input() extras?: { title: string; description: string; icon?: string }[];
  @Input() linkLocation?: string;
  @Input() linkTitle?: string;
  @Input() marginBottom?: string;
  @Input() title: string = '';
}
